import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Autocomplete,
  TextField
} from "@mui/material";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import swal from "sweetalert2";
import { api } from "utils/Api";
import { showWarning } from "utils/messageAlerts";
import { showSuccess } from "utils/messageAlerts";

function AdminAddOrganizationPopup({ onClose, refreshData }) {
  const [loading, setLoading] = useState(false);
  const [assignedUserEmail, setAssignedUserEmail] = useState("");
  const [orgs, setOrgs] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState(null);

  useEffect(() => {
    fetchOrgs();
  }, []);

  const fetchOrgs = async () => {
    try {
      const orgData = await api.su_Organiation.getSuOrgs();
      setOrgs(orgData || []);
    } catch (e) {}
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedOrg) {
      showWarning("Please select an organization");
      return;
    }

    if (!assignedUserEmail) {
      showWarning("Please enter a user email");
      return;
    }

    setLoading(true);

    try {
      await api.su_Organiation.postUserToOrg({
        user_email: assignedUserEmail,
        organization_id: selectedOrg.id,
        user_role_id: 2,
        frontend_metadata: {},
        backend_metadata: {},
      });

      showSuccess("User assigned successfully");

      onClose();
      refreshData();
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>Add User to Organization</DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

            {/* Searchable Organization */}
            <SoftBox>
              <SoftTypography variant="caption" fontWeight="bold">
                Select Organization <Box component="span" color="error.main">*</Box>
              </SoftTypography>

              <Autocomplete
                options={orgs}
                getOptionLabel={(option) => option.name || ""}
                value={selectedOrg}
                onChange={(event, newValue) => setSelectedOrg(newValue)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search organization..."
                    size="small"
                  />
                )}
              />
            </SoftBox>

            {/* User Email */}
            <SoftBox>
              <SoftTypography variant="caption" fontWeight="bold">
                User Email <Box component="span" color="error.main">*</Box>
              </SoftTypography>

              <SoftInput
                type="email"
                placeholder="Enter user email to assign as ADMIN"
                value={assignedUserEmail}
                onChange={(e) => setAssignedUserEmail(e.target.value)}
                required
              />
            </SoftBox>

          </Box>
        </DialogContent>

        <DialogActions>
          <SoftButton onClick={onClose}>Cancel</SoftButton>
          <SoftButton
            variant="gradient"
            color="dark"
            disabled={loading}
            type="submit"
          >
            {loading ? "Saving..." : "Save"}
          </SoftButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}

AdminAddOrganizationPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  refreshData: PropTypes.func.isRequired,
};

export default AdminAddOrganizationPopup;